import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import phonerecap1 from './pictures/phonerecap1.jpeg';
import phonerecap2 from './pictures/phonerecap2.jpeg';

const Phone = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Phone Charms Decorating Event!</h2>
                    <p class="site-post-meta">April 17th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    <br></br>
                    

                    Last Thursday, WiC had our 1st Member Meeting of Spring Quarter! 🌸

                    Thank you to everyone who attended, and we hope you all enjoy the phone charms you made (P.S. all the officers think they’re all very cute) 💐!

                    <br></br>
                    <br></br>

                    We will be having our Clean Power Research Event on Tuesday, April 29th  from 9:30 am - 11:30 am @ The Clean Power Research Office (Bellevue) and Hiya Career Trek on Thursday, May 8th from 1:00 pm - 3:00 pm @ The Hiya Office (Columbia Center). Hope to see you there! :)

                    <br></br>
                    <br></br>

                    Follow our Instagram @uw.wic for updates and future events!

                    
                    </p>
                    <img src={phonerecap1} alt="pic1"/>
                    <img src={phonerecap2} alt="pic2"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Phone;
